import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../../lib/analytics';

export function AnalyticsTracker(): null {
  const location = useLocation();

  useEffect(() => {
    const handle = setTimeout(() => {
      trackPageView(location.pathname + location.search);
    }, 100);
    return () => clearTimeout(handle);
  }, [location]);

  return null;
}
